<template>
  <!-- Page Content -->
  <div class="whole-page" id="whole-page-div">
    <div class="navbar-div">
      <Navbar
        analysis="TOOLS"
        :colorTheme="colorTheme"
        :user="user"
        @eventOnUserColorTheme="onUserColorTheme"
      />
    </div>

    <div class="h-100 d-flex flex-column">
      <!-- Selectors -->
      <div
        class="row f-row justify-content-center mt-2"
        style="font-size: 0.8em;"
      >
        <div class="col inline-ul text-center">
          <span v-if="this.showLoadingCurr" class="text-right">
            <v-progress-circular
              indeterminate
              :size="14"
              :width="1.5"
              color="primary"
            ></v-progress-circular>
          </span>
          Currencies:
          <button
            v-on:click="downloadCurrencies"
            type="submit"
            class="btn btn-up-dn-load"
          >
            <i class="fa fa-download" aria-hidden="true"></i>
          </button>
        </div>
        <div class="col inline-ul text-center">
          <span v-if="this.showLoadingCurrVal" class="text-right">
            <v-progress-circular
              indeterminate
              :size="14"
              :width="1.5"
              color="primary"
            ></v-progress-circular>
          </span>
          FX Valuation:
          <button
            v-on:click="downloadCurrencyValuation"
            type="submit"
            class="btn btn-up-dn-load"
          >
            <i class="fa fa-download" aria-hidden="true"></i>
          </button>
        </div>
        <div class="col inline-ul text-center">
          <span v-if="this.showLoadingCurrFwd" class="text-right">
            <v-progress-circular
              indeterminate
              :size="14"
              :width="1.5"
              color="primary"
            ></v-progress-circular>
          </span>
          FX Fwd:
          <button
            v-on:click="downloadCurrencyFwd"
            type="submit"
            class="btn btn-up-dn-load"
          >
            <i class="fa fa-download" aria-hidden="true"></i>
          </button>
        </div>
        <div class="col inline-ul text-center">
          <span v-if="this.showLoadingCurrVols" class="text-right">
            <v-progress-circular
              indeterminate
              :size="14"
              :width="1.5"
              color="primary"
            ></v-progress-circular>
          </span>
          FX Vol:
          <button
            v-on:click="downloadCurrencyVol"
            type="submit"
            class="btn btn-up-dn-load"
          >
            <i class="fa fa-download" aria-hidden="true"></i>
          </button>
        </div>
        <div class="col inline-ul text-center">
          <span v-if="this.showLoadingComm" class="text-right">
            <v-progress-circular
              indeterminate
              :size="14"
              :width="1.5"
              color="primary"
            ></v-progress-circular>
          </span>
          Commodities:
          <button
            v-on:click="downloadCommodities"
            type="submit"
            class="btn btn-up-dn-load"
          >
            <i class="fa fa-download" aria-hidden="true"></i>
          </button>
        </div>
        <div class="col inline-ul text-center">
          <span v-if="this.showLoadingIR" class="text-right">
            <v-progress-circular
              indeterminate
              :size="14"
              :width="1.5"
              color="primary"
            ></v-progress-circular>
          </span>
          Interest rates:
          <button
            v-on:click="downloadIR"
            type="submit"
            class="btn btn-up-dn-load"
          >
            <i class="fa fa-download" aria-hidden="true"></i>
          </button>
        </div>
        <div class="col inline-ul text-center">
          <span v-if="this.showLoadingETF" class="text-right">
            <v-progress-circular
              indeterminate
              :size="14"
              :width="1.5"
              color="primary"
            ></v-progress-circular>
          </span>
          ETFs:
          <button
            v-on:click="downloadETFs"
            type="submit"
            class="btn btn-up-dn-load"
          >
            <i class="fa fa-download" aria-hidden="true"></i>
          </button>
        </div>
        <div class="col inline-ul text-center">
          <span v-if="this.showLoadingInd" class="text-right">
            <v-progress-circular
              indeterminate
              :size="14"
              :width="1.5"
              color="primary"
            ></v-progress-circular>
          </span>
          Indices:
          <button
            v-on:click="downloadIndices"
            type="submit"
            class="btn btn-up-dn-load"
          >
            <i class="fa fa-download" aria-hidden="true"></i>
          </button>
        </div>
        <div class="col inline-ul text-center">
          <span v-if="this.showLoadingFut" class="text-right">
            <v-progress-circular
              indeterminate
              :size="14"
              :width="1.5"
              color="primary"
            ></v-progress-circular>
          </span>
          Futures:
          <button
            v-on:click="downloadFutures"
            type="submit"
            class="btn btn-up-dn-load"
          >
            <i class="fa fa-download" aria-hidden="true"></i>
          </button>
        </div>
      </div>
      <div class="row f-row justify-content-center" style="font-size: 0.8em;">
        <div class="col text-center selectDiv" style="padding: 0 2px 0 2px">
          <select class="dropdown-form">
            <option
              v-for="currency in currencySpecs"
              :value="currency.pk_i_idcurrency"
              :key="currency.pk_i_idcurrency"
              >{{ currency.currency_name.toUpperCase() }}
            </option>
          </select>
        </div>
        <div class="col text-center selectDiv" style="padding: 0 2px 0 2px">
          <select class="dropdown-form">
            <option
              v-for="currency in currencySpecs"
              :value="currency.pk_i_idcurrency"
              :key="currency.pk_i_idcurrency"
              >{{ currency.currency_name.toUpperCase() }}
            </option>
          </select>
        </div>
        <div class="col text-center selectDiv" style="padding: 0 2px 0 2px">
          <select class="dropdown-form">
            <option
              v-for="currency in currencySpecs"
              :value="currency.pk_i_idcurrency"
              :key="currency.pk_i_idcurrency"
              >{{ currency.currency_name.toUpperCase() }}
            </option>
          </select>
        </div>
        <div class="col text-center selectDiv" style="padding: 0 2px 0 2px">
          <select class="dropdown-form">
            <option
              v-for="currency in currencySpecs"
              :value="currency.pk_i_idcurrency"
              :key="currency.pk_i_idcurrency"
              >{{ currency.currency_name.toUpperCase() }}
            </option>
          </select>
        </div>
        <div class="col text-center selectDiv" style="padding: 0 2px 0 2px">
          <select class="dropdown-form">
            <option
              v-for="comm in commoditySpecs"
              :value="comm.pk_idcommodity"
              :key="comm.pk_idcommodity"
              >{{ comm.fk_idproduct.toUpperCase() }}
            </option>
          </select>
        </div>
        <div class="col text-center selectDiv" style="padding: 0 2px 0 2px">
          <select class="dropdown-form">
            <option
              v-for="ir in irSpecs"
              :value="ir.pk_idinterestrate"
              :key="ir.pk_idinterestrate"
              >{{ ir.interest_rate_name.toUpperCase() }}
            </option>
          </select>
        </div>
        <div class="col text-center selectDiv" style="padding: 0 2px 0 2px">
          <select class="dropdown-form">
            <option
              v-for="etf in etfSpecs"
              :value="etf.pk_i_idetf"
              :key="etf.pk_i_idetf"
              >{{ etf.short_name.toUpperCase() }}
            </option>
          </select>
        </div>
        <div class="col text-center selectDiv" style="padding: 0 2px 0 2px">
          <select class="dropdown-form">
            <option
              v-for="index in indexSpecs"
              :value="index.pk_i_idindexes"
              :key="index.pk_i_idindexes"
              >{{ index.short_name.toUpperCase() }}
            </option>
          </select>
        </div>
        <div class="col text-center selectDiv" style="padding: 0 2px 0 2px">
          <select class="dropdown-form">
            <option
              v-for="fut in futuresSpecs"
              :value="fut.pk_i_idfutures"
              :key="fut.pk_i_idfutures"
              >{{ fut.short_name.toUpperCase() }}
            </option>
          </select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SheetsTransaction } from "@/_core/export/SheetsTransaction";
import { apiService } from "@/_services";
import { colorThemeVuex, formatDate_YMD } from "@/_core/_helpers/_helpers";
import { timeParse } from "d3";
import Navbar from "@/components/Navbar.vue";

export default {
  name: "tools",
  components: {
    Navbar
  },
  data() {
    return {
      colorTheme: true, // true = dark, else light
      user: [],
      showLoadingCurr: false,
      showLoadingCurrFwd: false,
      showLoadingCurrVols: false,
      showLoadingComm: false,
      showLoadingCurrVal: false,
      showLoadingETF: false,
      showLoadingInd: false,
      showLoadingFut: false,
      showLoadingIR: false,
      initialDate: [],
      currenciesData: [],
      currencyValuationData: [],
      currencyFwdData: [],
      currencyVolData: [],
      commoditiesData: [],
      irData: [],
      etfsData: [],
      indicesData: [],
      futuresData: [],
      dataToExport: [],
      headersToExport: [],
      list_file: "",
      currencySpecs: [{ pk_i_idcurrency: 0, currency_name: "N.A" }],
      currencyPKs: [],
      etfPKs: [],
      indexPKs: [],
      irPKs: [],
      futuresPKs: [],
      commoditySpecs: [{ pk_idcommodity: 0, fk_idproduct: "N.A" }],
      irSpecs: [{ pk_idinterestrate: 0, interest_rate_name: "N.A" }],
      etfSpecs: [{ pk_i_idetf: 0, short_name: "N.A" }],
      indexSpecs: [{ pk_i_idindexes: 0, short_name: "N.A" }],
      futuresSpecs: [{ pk_i_idfutures: 0, short_name: "N.A" }],
      currencyHeaders: [
        { text: "pk", value: "pk_idcurrencyhistorical" },
        { text: "date", value: "date" },
        { text: "open", value: "open" },
        { text: "high", value: "high" },
        { text: "low", value: "low" },
        { text: "close", value: "close" },
        { text: "settle", value: "settle" },
        { text: "asset", value: "asset" }
      ],
      currencyFwdHeaders: [
        { text: "pk", value: "pk_idcurrencyforward" },
        { text: "date", value: "date" },
        { text: "close", value: "last" },
        { text: "bid", value: "bid" },
        { text: "ask", value: "ask" },
        { text: "days_2_exp", value: "days_to_expiration" },
        { text: "term", value: "term" },
        { text: "asset", value: "asset" }
      ],
      currencyVolHeaders: [
        { text: "pk", value: "pk_idcurrencyvolatility" },
        { text: "date", value: "date" },
        { text: "close", value: "last" },
        { text: "bid", value: "bid" },
        { text: "ask", value: "ask" },
        { text: "days_2_exp", value: "days_to_expiration" },
        { text: "term", value: "term" },
        { text: "asset", value: "asset" },
        { text: "delta", value: "delta" },
        { text: "delta type", value: "delta_type" }
      ],
      irHeaders: [
        { text: "pk", value: "MInterestRateHistorical" },
        { text: "date", value: "date" },
        { text: "open", value: "open" },
        { text: "high", value: "high" },
        { text: "low", value: "low" },
        { text: "close", value: "close" },
        { text: "settle", value: "settle" },
        { text: "asset", value: "asset" },
        { text: "source", value: "fk_iddatasource" },
        { text: "days_2_exp", value: "days_to_expiration" },
        { text: "term", value: "term" }
      ],
      etfHeaders: [
        { text: "pk", value: "pk_idetfhistorical" },
        { text: "date", value: "date" },
        { text: "open", value: "open" },
        { text: "high", value: "high" },
        { text: "low", value: "low" },
        { text: "close", value: "close" },
        { text: "settle", value: "settle" },
        { text: "volume", value: "volumes" },
        { text: "asset", value: "asset" }
      ],
      indexHeaders: [
        { text: "pk", value: "pk_idindexeshistorical" },
        { text: "date", value: "date" },
        { text: "open", value: "open" },
        { text: "high", value: "high" },
        { text: "low", value: "low" },
        { text: "close", value: "close" },
        { text: "settle", value: "settle" },
        { text: "volume", value: "volumes" },
        { text: "asset", value: "asset" }
      ],
      futuresHeaders: [
        { text: "pk", value: "pk_idfutureshistorical" },
        { text: "date", value: "date" },
        { text: "open", value: "open" },
        { text: "high", value: "high" },
        { text: "low", value: "low" },
        { text: "close", value: "close" },
        { text: "settle", value: "settle" },
        { text: "volume", value: "volumes" },
        { text: "asset", value: "asset" }
      ],
      currencyValHeaders: [
        { text: "pk", value: "pk_idcurrencyvaluationinput" },
        { text: "date", value: "date" },
        { text: "days", value: "days_to_expiration" },
        { text: "fwd", value: "fwd" },
        { text: "r", value: "r" },
        { text: "rf", value: "rf" },
        { text: "d0", value: "d0" },
        { text: "c0", value: "c0" },
        { text: "c1", value: "c1" },
        { text: "c2", value: "c2" },
        { text: "asset", value: "asset" }
      ],
      commoditiesPKs: [],
      commodityHeaders: [
        { text: "pk", value: "pk_idcommoditieshistorical" },
        { text: "date", value: "date" },
        { text: "open", value: "open" },
        { text: "high", value: "high" },
        { text: "low", value: "low" },
        { text: "close", value: "close" },
        { text: "settle", value: "settle" },
        { text: "volume", value: "volumes" },
        { text: "openInt", value: "openinterest" },
        { text: "asset", value: "asset" }
      ]
    };
  },
  created() {
    try {
      this.sheetTransaction = new SheetsTransaction(
        this.dataToExport,
        this.headersToExport
      );
    } catch (error) {
      console.log(`Error Process Data ${error}`);
    }
    try {
      this.user = this.$store.state.user.all.items;
      console.log("User");
    } catch (error) {
      console.log(`Error user ${error}`);
    }
    try {
      this.currencySpecs = this.$store.state.currencies.all.items;
      this.currencyPKs = this.currencySpecs.map(d => d.pk_i_idcurrency);
    } catch (error) {
      console.log(`Error currencies ${error}`);
    }

    let dat = new Date();
    dat.setMonth(dat.getMonth() - 3, dat.getDay());
    this.initialDate = dat;

    // this.readCommoditiesSpecs();
    try {
      this.commoditySpecs = this.$store.state.commodities.all.items;
      this.commoditiesPKs = this.commoditySpecs.map(d => d.pk_idcommodity);
      this.readCommoditiesData();
    } catch (error) {
      console.log(`Error currencies ${error}`);
    }
    this.readCurrenciesData();
    this.readCurrencyFwdData();
    this.readCurrencyVolData();
    this.readCurrencyValuationData();
    this.readIRSpecs();
    this.readETFSpecs();
    this.readIndexSpecs();
    this.readFuturesSpecs();

    document.title = "Tools | Quanspire";
  },
  methods: {
    onUserColorTheme(val) {
      this.colorTheme = val;
      this.overview_preferences.color_theme = val;
      colorThemeVuex(this, this.colorTheme);
      // saveUserPreferences(this);
    },
    // ====================== Downloads ====================== //
    downloadIR() {
      this.showLoadingIR = true;
      this.list_file = ["ir"];
      this.headersToExport = this.irHeaders;
      this.sheetTransaction.set_data(this.irData);
      this.sheetTransaction.set_headers(this.headersToExport);
      this.sheetTransaction.export(this.list_file);
      this.showLoadingIR = false;
    },
    downloadFutures() {
      this.showLoadingFut = true;
      this.list_file = ["fut"];
      this.headersToExport = this.futuresHeaders;
      this.sheetTransaction.set_data(this.futuresData);
      this.sheetTransaction.set_headers(this.headersToExport);
      this.sheetTransaction.export(this.list_file);
      this.showLoadingFut = false;
    },
    downloadIndices() {
      this.showLoadingInd = true;
      this.list_file = ["ind"];
      this.headersToExport = this.indexHeaders;
      this.sheetTransaction.set_data(this.indicesData);
      this.sheetTransaction.set_headers(this.headersToExport);
      this.sheetTransaction.export(this.list_file);
      this.showLoadingInd = false;
    },
    downloadETFs() {
      this.showLoadingETF = true;
      this.list_file = ["etf"];
      this.headersToExport = this.etfHeaders;
      this.sheetTransaction.set_data(this.etfsData);
      this.sheetTransaction.set_headers(this.headersToExport);
      this.sheetTransaction.export(this.list_file);
      this.showLoadingETF = false;
    },
    downloadCurrencyFwd() {
      this.showLoadingCurrFwd = true;
      this.list_file = ["currFwd"];
      this.headersToExport = this.currencyFwdHeaders;
      this.sheetTransaction.set_data(this.currencyFwdData);
      this.sheetTransaction.set_headers(this.headersToExport);
      this.sheetTransaction.export(this.list_file);
      this.showLoadingCurrFwd = false;
    },
    downloadCurrencyVol() {
      this.showLoadingCurrVols = true;
      this.list_file = ["currVol"];
      this.headersToExport = this.currencyVolHeaders;
      this.sheetTransaction.set_data(this.currencyVolData);
      this.sheetTransaction.set_headers(this.headersToExport);
      this.sheetTransaction.export(this.list_file);
      this.showLoadingCurrVols = false;
    },
    downloadCurrencyValuation() {
      this.showLoadingCurrVal = true;
      this.list_file = ["currVal"];
      this.headersToExport = this.currencyValHeaders;
      this.sheetTransaction.set_data(this.currencyValuationData);
      this.sheetTransaction.set_headers(this.headersToExport);
      this.sheetTransaction.export(this.list_file);
      this.showLoadingCurrVal = false;
    },
    downloadCurrencies() {
      this.showLoadingCurr = true;
      this.list_file = ["curr"];
      this.headersToExport = this.currencyHeaders;
      this.sheetTransaction.set_data(this.currenciesData);
      this.sheetTransaction.set_headers(this.headersToExport);
      this.sheetTransaction.export(this.list_file);
      this.showLoadingCurr = false;
    },
    downloadCommodities() {
      this.showLoadingComm = true;
      this.list_file = ["comm"];
      this.headersToExport = this.commodityHeaders;
      this.sheetTransaction.set_data(this.commoditiesData);
      this.sheetTransaction.set_headers(this.headersToExport);
      this.sheetTransaction.export(this.list_file);
      this.showLoadingComm = false;
    },

    // ====================== APIS ====================== //
    readIRSpecs() {
      this.showLoadingIR = true;
      let _this = this;

      let params = {
        method: "GET",
        endpoint: "interest-rates",
        query_params: { format: "json" }
      };
      return apiService
        .getAll(params)
        .then(data => {
          this.irSpecs = data;
          this.irPKs = this.irSpecs.map(d => d.pk_idinterestrate);
          this.readIRData();
        })
        .catch(function(error) {
          _this.showLoadingIR = false;
          _this.irSpecs = [];
          _this.irPKs = [];
          console.log(error);
        });
    },
    readIRData() {
      this.showLoadingIR = true;
      let _this = this;

      let params = {
        method: "GET",
        endpoint: "interest-rate-history",
        query_params: {
          format: "json",
          observation_date: formatDate_YMD(this.initialDate)
        }
      };
      return apiService
        .getAll(params)
        .then(data => {
          data.forEach(function(d) {
            d.date = timeParse("%Y-%m-%d")(d.observation_date);
            // d.asset = _this.irSpecs[_this.irPKs.indexOf(d.fk_idinterestrate)].interest_rate_name;
            d.asset = d.fk_idinterestrate;
          });
          this.irData = data;
          _this.showLoadingIR = false;
        })
        .catch(function(error) {
          _this.showLoadingIR = false;
          _this.irData = [];
          console.log(error);
        });
    },

    readFuturesSpecs() {
      this.showLoadingFut = true;
      let _this = this;

      let params = {
        method: "GET",
        endpoint: "futures",
        query_params: { format: "json" }
      };
      return apiService
        .getAll(params)
        .then(data => {
          this.futuresSpecs = data;
          this.futuresPKs = this.futuresSpecs.map(d => d.pk_i_idfutures);
          this.readFuturesData();
        })
        .catch(function(error) {
          _this.showLoadingFut = false;
          _this.futuresSpecs = [];
          _this.futuresPKs = [];
          console.log(error);
        });
    },
    readFuturesData() {
      this.showLoadingFut = true;
      let _this = this;

      let params = {
        method: "GET",
        endpoint: "futures-history",
        query_params: {
          format: "json",
          observation_date: formatDate_YMD(this.initialDate)
        }
      };
      return apiService
        .getAll(params)
        .then(data => {
          data.forEach(function(d) {
            d.date = timeParse("%Y-%m-%d")(d.observation_date);
            d.asset =
              _this.futuresSpecs[
                _this.futuresPKs.indexOf(d.fk_future)
              ].short_name;
          });
          this.futuresData = data;
          _this.showLoadingFut = false;
        })
        .catch(function(error) {
          _this.showLoadingFut = false;
          _this.futuresData = [];
          console.log(error);
        });
    },

    readIndexSpecs() {
      this.showLoadingInd = true;
      let _this = this;

      let params = {
        method: "GET",
        endpoint: "indexes",
        query_params: { format: "json" }
      };
      return apiService
        .getAll(params)
        .then(data => {
          this.indexSpecs = data;
          this.indexPKs = this.indexSpecs.map(d => d.pk_i_idindexes);
          this.readIndexData();
        })
        .catch(function(error) {
          _this.showLoadingInd = false;
          _this.indexSpecs = [];
          _this.indexPKs = [];
          console.log(error);
        });
    },
    readIndexData() {
      this.showLoadingInd = true;
      let _this = this;

      let params = {
        method: "GET",
        endpoint: "index-history",
        query_params: {
          format: "json",
          observation_date: formatDate_YMD(this.initialDate)
        }
      };
      return apiService
        .getAll(params)
        .then(data => {
          data.forEach(function(d) {
            d.date = timeParse("%Y-%m-%d")(d.observation_date);
            d.asset =
              _this.indexSpecs[_this.indexPKs.indexOf(d.fk_index)].short_name;
          });
          this.indicesData = data;
          _this.showLoadingInd = false;
        })
        .catch(function(error) {
          _this.showLoadingInd = false;
          _this.indicesData = [];
          console.log(error);
        });
    },

    readETFSpecs() {
      this.showLoadingETF = true;
      let _this = this;

      let params = {
        method: "GET",
        endpoint: "etfs",
        query_params: { format: "json" }
      };
      return apiService
        .getAll(params)
        .then(data => {
          this.etfSpecs = data;
          this.etfPKs = this.etfSpecs.map(d => d.pk_i_idetf);
          this.readETFData();
        })
        .catch(function(error) {
          _this.showLoadingETF = false;
          _this.etfSpecs = [];
          _this.etfPKs = [];
          console.log(error);
        });
    },
    readETFData() {
      this.showLoadingETF = true;
      let _this = this;

      let params = {
        method: "GET",
        endpoint: "etf-history",
        query_params: {
          format: "json",
          observation_date: formatDate_YMD(this.initialDate)
        }
      };
      return apiService
        .getAll(params)
        .then(data => {
          data.forEach(function(d) {
            d.date = timeParse("%Y-%m-%d")(d.observation_date);
            d.asset =
              _this.etfSpecs[_this.etfPKs.indexOf(d.fk_idetf)].short_name;
          });
          this.etfsData = data;
          _this.showLoadingETF = false;
        })
        .catch(function(error) {
          _this.showLoadingETF = false;
          _this.etfsData = [];
          console.log(error);
        });
    },

    readCurrencyValuationData() {
      this.showLoadingCurrVal = true;
      let _this = this;

      let params = {
        method: "GET",
        endpoint: "currency-valuation-inputs",
        query_params: {
          format: "json",
          last: 1
        }
      };
      // console.log(_this.currencySpecs)
      // console.log(_this.currencyPKs)
      return apiService
        .getAll(params)
        .then(data => {
          data.forEach(function(d) {
            d.date = timeParse("%Y-%m-%dT%H:%M:%S.%LZ")(d.observation_date);
          });
          this.currencyValuationData = data;
          _this.showLoadingCurrVal = false;
        })
        .catch(function(error) {
          _this.showLoadingCurrVal = false;
          _this.currencyValuationData = [];
          console.log(error);
        });
    },

    // readCommoditiesSpecs() {
    //   this.showLoadingComm = true;
    //   let _this = this;
    //
    //   let params = {
    //     method: "GET",
    //     endpoint: "commodities",
    //     query_params: {
    //       format: "json"
    //     }
    //   };
    //   return apiService
    //     .getAll(params)
    //     .then(data => {
    //       this.commoditySpecs = data;
    //       this.commoditiesPKs = this.commoditySpecs.map(d => d.pk_idcommodity);
    //       this.readCommoditiesData();
    //     })
    //     .catch(function(error) {
    //       _this.showLoadingComm = false;
    //       _this.commoditySpecs = [];
    //       _this.commoditiesPKs = [];
    //       console.log(error);
    //     });
    // },
    readCommoditiesData() {
      this.showLoadingComm = true;
      let _this = this;

      let params = {
        method: "GET",
        endpoint: "commodities-history",
        query_params: {
          format: "json",
          observation_date: formatDate_YMD(this.initialDate)
        }
      };
      return apiService
        .getAll(params)
        .then(data => {
          data.forEach(function(d) {
            d.date = timeParse("%Y-%m-%d")(d.observation_date);
            d.asset =
              _this.commoditySpecs[
                _this.commoditiesPKs.indexOf(d.fk_commodities)
              ].fk_idproduct +
              " " +
              d.continuous_contract;
          });
          this.commoditiesData = data;
          this.showLoadingComm = false;
        })
        .catch(function(error) {
          _this.showLoadingComm = false;
          _this.commoditiesData = [];
          console.log(error);
        });
    },

    readCurrencyFwdData() {
      this.showLoadingCurrFwd = true;
      let _this = this;

      let params = {
        method: "GET",
        endpoint: "currency-forward",
        query_params: {
          format: "json",
          observation_date: formatDate_YMD(this.initialDate)
        }
      };
      return apiService
        .getAll(params)
        .then(data => {
          data.forEach(function(d) {
            d.date = timeParse("%Y-%m-%d")(d.observation_date);
            d.asset =
              _this.currencySpecs[
                _this.currencyPKs.indexOf(d.fk_idcurrency)
              ].currency_name;
          });
          this.currencyFwdData = data;
          _this.showLoadingCurrFwd = false;
        })
        .catch(function(error) {
          _this.showLoadingCurrFwd = false;
          _this.currencyFwdData = [];
          console.log(error);
        });
    },

    readCurrencyVolData() {
      this.showLoadingCurrVols = true;
      let _this = this;

      let params = {
        method: "GET",
        endpoint: "currency-volatility",
        query_params: {
          format: "json",
          observation_date: formatDate_YMD(this.initialDate)
        }
      };
      return apiService
        .getAll(params)
        .then(data => {
          data.forEach(function(d) {
            d.date = timeParse("%Y-%m-%d")(d.observation_date);
            d.asset =
              _this.currencySpecs[
                _this.currencyPKs.indexOf(d.fk_idcurrency)
              ].currency_name;
          });
          this.currencyVolData = data;
          _this.showLoadingCurrVols = false;
        })
        .catch(function(error) {
          _this.showLoadingCurrVols = false;
          _this.currencyVolData = [];
          console.log(error);
        });
    },

    readCurrenciesData() {
      this.showLoadingCurr = true;
      let _this = this;
      const currPKName = {};
      this.currencySpecs.forEach(function(d) {
        currPKName[d.pk_i_idcurrency] = d.currency_name;
      });

      let params = {
        method: "GET",
        endpoint: "total_technicalanalysis_historical",
        query_params: {
          format: "json",
          observation_date: formatDate_YMD(this.initialDate)
        }
      };
      return apiService
        .getAll(params)
        .then(data => {
          data.forEach(function(d) {
            d.date = timeParse("%Y-%m-%d")(d.observation_date);
            d.asset = currPKName[d.fk_idcurrency];
          });
          this.currenciesData = data;
          this.showLoadingCurr = false;
        })
        .catch(function(error) {
          _this.showLoadingCurr = false;
          _this.currenciesData = [];
          console.log(error);
        });
    }
  }
};
</script>
